import InputCheckbox from './InputCheckbox'

export default InputCheckbox



// WEBPACK FOOTER //
// ./src/components/InputCheckbox/index.js